import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Class composer. `twMerge` is what makes the primitives genuinely reusable:
 * a caller can pass `className="w-full"` or `className="px-6"` and it replaces
 * the component's own conflicting utility instead of both landing in the class
 * list and letting source order decide.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
